// extracted by mini-css-extract-plugin
export default {"buttonsGroup":"AX6Pk","orderUrl":"FHyUB","description":"wCf1m"};